import { z } from "zod";

/** Freshness of the Postgres rows a listing was served from; `synced_at` null and no `failure` means the first sync is still queued. */
export const GithubSnapshot = z
  .object({
    synced_at: z.string().nullable(),
    attempted_at: z.string().nullable(),
    failure: z.string().nullable(),
  })
  .optional();
export type GithubSnapshot = z.infer<typeof GithubSnapshot>;

const SYNC_POLL_MS = 1000;

/** `refetchInterval` for a query whose response carries `snapshot`: poll while the first sync has neither landed nor failed. */
export function pollWhileSyncing<T extends { snapshot?: GithubSnapshot }>(
  data: T | undefined,
): number | false {
  const snapshot = data?.snapshot;
  return snapshot && snapshot.synced_at === null && snapshot.failure === null
    ? SYNC_POLL_MS
    : false;
}
